// Copyright (c) StrangeBee 2023

import { createContext } from 'react';

export const AvailableLanguagesArray = [
    'ar',
    'de',
    'en',
    'en_US',
    'es',
    'fr',
    'it',
    'ja',
    'nl',
    'pl',
    'pt_BR',
    'ru',
    'sv',
    'zh_Hans',
] as const;
export type AvailableLanguages = (typeof AvailableLanguagesArray)[number];

export type LanguageDirection = 'ltr' | 'rtl';

export interface StorageLanguageType {
    language: AvailableLanguages;
    direction: LanguageDirection;
}

export interface LanguageSwitcherContextInterface {
    language: AvailableLanguages;
    direction: LanguageDirection;
    setLanguage: (value: AvailableLanguages) => void;
    setDirection: (value: LanguageDirection) => void;
}

export const LanguageSwitcherContext = createContext<LanguageSwitcherContextInterface>({
    language: 'en',
    direction: 'ltr',
    setLanguage: () => ({}),
    setDirection: () => ({}),
});
